<template>
  <button class="btn btn-sm btn-default editor-popover-button" :style="buttonStyles" :disabled="disabled" @click.prevent="$emit('click', $event)">
    <i :class="['far', icon, actionButtonClass, 'mr-1']"></i> {{title}}
  </button>
</template>


<script>
export default {
  name: 'EditorPopoverButton',
  props: {
    icon: {
      type: String,
      default: 'fa-check'
    },
    type: {
      type: String,
      default: 'update'
    },
    title: String,
    width: {
      type: Number,
      default: 1
    },
    disabled: Boolean
  },
  computed: {
    buttonStyles() {
      return {
        'flex-grow': this.width
      }
    },
    actionButtonClass() {
      var classMap = {
        cancel: 'editor-popover-buttontype-edit',
        edit: 'editor-popover-buttontype-edit',
        action: 'editor-popover-buttontype-action',
        update: 'editor-popover-buttontype-update',
        remove: 'editor-popover-buttontype-remove'
      }
      return classMap[this.type] || 'status-approved'
    }
  }
}
</script>